'use client'

import NewVisaUnifiedFlow from './unifiedFlow'

const NewVisaDetailsContainerDesktop = ({
    initialStep
}: {
    initialStep: number
}) => {
    return (
        <>
            <NewVisaUnifiedFlow initialStep={initialStep} />
        </>
    )
}

export default NewVisaDetailsContainerDesktop